<template>
  <b-table
      :fields="fields"
      :items="items"
      table-class="text-nowrap"
      responsive
  >
    <template #cell(license)="data">
      <b-badge v-if="data.item.license.is_approved" variant="success">Approved</b-badge>
      <b-badge v-else variant="danger">Not Approved</b-badge>
      <b-badge variant="info">Packages Last Polled: {{ data.item.last_polled_at }}</b-badge>
      <h4 class="mb-0 mt-1">{{ data.item.license.number }}</h4>
      Type: {{ data.item.license_type }}
      <template v-if="data.item.license_issued">
        <br>
        Issued: {{ data.item.license_issued }}
      </template>
      <template v-if="data.item.license_expires">
        <br>
        Expires: {{ data.item.license_expires }}
      </template>
      <div>
        <no-permission-wrapper :show="!canResyncLicenses">
          <b-btn
            variant="primary"
            size="xs"
            @click="() => onClickResyncLicense(data.item.license, 'packages')"
            :disabled="!canResyncLicenses"
          >
            Resync Packages
          </b-btn>
          <b-btn
            variant="primary"
            size="xs"
            @click="() => onClickResyncLicense(data.item.license, 'transfers')"
            :disabled="!canResyncLicenses"
          >
            Resync Transfers
          </b-btn>
        </no-permission-wrapper>
      </div>
    </template>
      <template #cell(company)="data">
        <b-link :to="{name: 'admin-company', params: {id: data.item.company.id}}">{{ data.item.company.name }}</b-link>
      </template>
    <template #cell(facility)="data">
      <strong>{{ data.item.license.facility.name }}</strong>
      <template v-if="data.item.facility_street_address">
        <br>
        {{ data.item.facility_street_address }}
      </template>
      <template v-if="data.item.facility_city_address">
        <br>
        {{ data.item.facility_city_address }}
      </template>
    </template>
<!--    <template #cell(status)="data">-->
<!--      <b-badge v-if="data.item.license.is_approved" variant="success">Approved</b-badge>-->
<!--      <b-badge v-else variant="danger">Not Approved</b-badge>-->
<!--    </template>-->
    <template #cell(permissions)="data">
      <b-badge v-if="data.item.license.is_to_buy" variant="success">Purchases</b-badge>
      <b-badge v-else variant="danger">No Purchases</b-badge>

      <b-badge v-if="data.item.license.is_to_sell" variant="success">Sales</b-badge>
      <b-badge v-else variant="danger">No Sales</b-badge>
    </template>
    <template #cell(actions)="data">
      <no-permission-wrapper :show="!canUpdateLicenses">
        <b-btn
            v-if="!data.item.license.is_approved"
            @click.prevent="() => onClickApproveLicense(data.item.license)"
            variant="success"
            :disabled="!canUpdateLicenses"
        >
          Approve
        </b-btn>
        <b-btn
            v-else
            @click.prevent="() => onClickDisapproveLicense(data.item.license)"
            variant="danger"
            :disabled="!canUpdateLicenses"
        >
          Disapprove
        </b-btn>
      </no-permission-wrapper>
    </template>
  </b-table>
</template>

<script>
import {convertFromUtc} from "../helpers";
import NoPermissionWrapper from "./NoPermissionWrapper.vue";

export default {
  name: "AdminLicensesTable",
  components: {NoPermissionWrapper},
  emits: ['approve', 'disapprove', 'resync'],
  props: {
    licenses: {
      type: Array,
      required: true
    },
    withActions: {
      type: Boolean,
      default: false
    },
    withCompany: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    canUpdateLicenses() {
      return this.$store.getters['auth/hasAdminPermissions']('license_update');
    },
    canResyncLicenses() {
      return this.$store.getters['auth/hasAdminPermissions']('license_resync');
    },
    items() {
      return this.licenses.map(license => {
        let addressStreetParts = [];
        if (license.location.address_line_1) {
          addressStreetParts.push(license.location.address_line_1);
        }
        if (license.location.address_line_2) {
          addressStreetParts.push(license.location.address_line_2);
        }
        let addressCityParts = [];
        if (license.location.address_city) {
          addressCityParts.push(license.location.address_city);
        }
        if (license.location.address_state) {
          addressCityParts.push(license.location.address_state);
        }
        if (license.location.address_zip) {
          addressCityParts.push(license.location.address_zip);
        }

        return {
          license: license,
          company: license.company,
          license_type: license.type?.name,
          license_issued: license.date_issue ? convertFromUtc(license.date_issue, 'L') : '',
          license_expires: license.date_expire ? convertFromUtc(license.date_expire, 'L') : '',
          facility_street_address: addressStreetParts.join(', '),
          facility_city_address: addressCityParts.join(', '),
          last_polled_at: license.packages_polling_status?.last_polled_at
            ? convertFromUtc(license.packages_polling_status.last_polled_at, 'L LT')
            : 'Never polled'
        }
      })
    },
    fields() {
      let fields = [
        {
          key: "license",
          thClass: "border-top-0",
          tdClass: "align-middle"
        },
        // {
        //   key: "status",
        //   thClass: "border-top-0",
        //   tdClass: "align-middle"
        // },
      ];
      if (this.withCompany) {
        fields.push({
          key: "company",
          thClass: "border-top-0",
          tdClass: "align-middle"
        });
      }
      fields.push({
        key: "facility",
        thClass: "border-top-0",
        tdClass: "align-middle"
      });
      fields.push({
        key: "permissions",
        thClass: "border-top-0",
        tdClass: "align-middle"
      });
      if (this.withActions) {
        fields.push({
          key: "actions",
          thClass: "border-top-0",
          tdClass: "align-middle"
        });
      }

      return fields;
    }
  },
  methods: {
    onClickApproveLicense(license) {
      this.$emit('approve', license);
    },
    onClickDisapproveLicense(license) {
      this.$emit('disapprove', license);
    },
    onClickResyncLicense(license, polling) {
      this.$emit('resync', {
        license,
        polling
      });
    }
  }
}
</script>
